import { Tag, TagDefinitions } from "../generated/UsedGeneratedTypes";

export type InternationalizeFn = (tagName: string) => string;

export interface GenericTag extends Tag {
  tagName: string;
  tagOrder?: number;
}

export class LocalTag implements GenericTag {
  // TODO - ajout du filtre des tag HIDDEN dans la liste
  static readonly NO_TAG_NAME = "no_tag";
  static readonly NO_TAG_DEFINITION: TagDefinitions = "NO_TAG" as TagDefinitions;

  tagName: string;
  tagDefinition: TagDefinitions;
  tagOrder?: number;
  selected: boolean = true;
  localName: string;

  constructor(genericTag?: GenericTag, internationalize?: InternationalizeFn) {
    const g = genericTag ?? {
      tagName: LocalTag.NO_TAG_NAME,
      tagDefinition: LocalTag.NO_TAG_DEFINITION,
    };

    this.tagName = g.tagName;
    this.tagDefinition = g.tagDefinition ?? LocalTag.NO_TAG_DEFINITION;
    this.tagOrder = g.tagOrder;
    this.localName = internationalize ? internationalize(this.tagName) : this.tagName;
  }

  findTagInTagList(listOfTags: Record<string, GenericTag>): LocalTag {
    return <LocalTag>Object.values(listOfTags).find(
      tag => tag.tagDefinition === this.tagDefinition && tag.tagName === this.tagName,
    );
  }
}
